import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';

const DefaultGameBanner = () => (
  <StaticQuery
    query=
      {graphql`
        query {
          bg: file(relativePath: { eq: "games/logout-game-banner.jpg" }) {
            childImageSharp {
              fluid(maxWidth: 1200) {
                ...GatsbyImageSharpFluid_withWebp_noBase64
              }
            }
          }
        }
      `}
    render={data => (
      <div className="game-banner">
        {data.bg.childImageSharp.fluid &&
          <Img alt="Logout Game Banner" fluid={data.bg.childImageSharp.fluid} fadeIn={false} loading='eager' />
        }
      </div>
    )}
  />
);

export default DefaultGameBanner;